import { apiCall } from "../../services/api-service.js";

const get = (endpoint, params, options = {}) =>
  apiCall("get", endpoint, null, { params, ...options }).then((r) => r.data);

const post = (endpoint, body) =>
  apiCall("post", endpoint, body).then((r) => r.data);

export const getTransactionsAPI      = (vendorId, params) => get(`get_transactions/${vendorId}`, params);
export const createPaymentAPI        = (payload)          => post("payment", payload);
export const addAttachmentAPI        = (payload)          => post("add_payment_attachment", payload);
export const getPaymentsAPI          = (params)           => get("payment", params);
export const viewPaymentAPI          = (id)               => get(`payment/view/${id}`);
export const getPaymentTransactionsAPI = (id, params)     => get(`payment/transactions/${id}`, params);
export const getPaymentHistoryListAPI = (params, options) => get("payment_history", params, options);
export const getPaymentHistoryAPI    = (id)               => get(`payment/history/${id}`);
export const getPaymentReconciliationListAPI = (params, options) => get("payment_reconciliation", params, options);
export const getUnlinkedBankTransactionsAPI = (params) => get("payment_reconciliation/unlinked_bank_txns", params);
export const linkTransactionAPI = (payload) => post("payment_reconciliation/link", payload);
export const validateReconciliationsAPI = (payload) => post("payment_reconciliation/validate", payload);
